import React, { useState } from 'react';
import useInView from '../../hooks/useInView';
import styles from './ExportServices.module.css';

const formats = [
  {
    letter: 'А',
    title: 'Агентская модель',
    subtitle: 'Работаем от вашего имени',
    description: 'Вы сохраняете полный контроль над брендом и переговорами. Мы выступаем вашим официальным торговым представителем: проводим встречи, согласовываем условия. Все контракты заключаются напрямую между вами и зарубежным клиентом. Вы получаете экспортную выручку на свой счет, а мы — агентское вознаграждение.',
    features: ['Полный контроль над брендом', 'Прямые контракты с клиентами', 'Экспортная выручка на ваш счёт', 'Представительство на переговорах']
  },
  {
    letter: 'Б',
    title: 'Трейдинг / Дистрибуция',
    subtitle: 'Работаем от своего имени',
    description: 'Мы покупаем продукцию у вас (или берем на комиссию) и самостоятельно занимаемся всем остальным: от таможенной очистки до международной логистики и получения валютной выручки. Для вас это выглядит как простая продажа на внутреннем рынке.',
    features: ['Простая продажа на внутреннем рынке', 'Вся логистика на нас', 'Таможенная очистка', 'Получение валютной выручки']
  }
];

export default function ExportServices() {
  const [activeFormat, setActiveFormat] = useState(0);
  const [ref, isVisible] = useInView();

  return (
    <section className={`${styles.section} ${isVisible ? styles.visible : ''}`} id="export" ref={ref}>
      <div className={styles.container}>
        <div style={{ textAlign: 'center' }}>
          <span className={styles.badge}>Экспорт</span>
        </div>
        <h2 className={styles.title}>Экспорт из России</h2>
        <p className={styles.subtitle}>
          Мы работаем так, как удобно вам. Хотите полного контроля — работаем от вашего имени.
          Хотите снять с себя все хлопоты — работаем от своего.
        </p>

        <div className={styles.tabs}>
          {formats.map((f, i) => (
            <button
              key={i}
              className={`${styles.tab} ${activeFormat === i ? styles.tabActive : ''}`}
              onClick={() => setActiveFormat(i)}
            >
              <span className={styles.tabLetter}>Формат {f.letter}</span>
              <span className={styles.tabTitle}>{f.title}</span>
            </button>
          ))}
        </div>

        <div className={styles.content}>
          <div className={styles.contentLeft}>
            <h3 className={styles.formatTitle}>
              Формат {formats[activeFormat].letter}. {formats[activeFormat].title}
            </h3>
            <p className={styles.formatSubtitle}>{formats[activeFormat].subtitle}</p>
            <p className={styles.formatDesc}>{formats[activeFormat].description}</p>
          </div>
          <div className={styles.contentRight}>
            <ul className={styles.featureList}>
              {formats[activeFormat].features.map((feat, i) => (
                <li key={i} className={styles.featureItem}>
                  <span className={styles.checkIcon}>✓</span>
                  {feat}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
